
import { Component, Vue, Prop, Emit, Ref, namespace } from 'nuxt-property-decorator';
import { Collapsible } from 'fourwaves-shared/components';
import { FeatureFlag, LocationWithRawQuery } from 'fourwaves-shared';
import UpgradeModal from '~/components/upgrade/UpgradeModal.vue';

const EventsModule = namespace('events');

@Component({
  components: {
    Collapsible,
    UpgradeModal,
  },
})
export default class NavItem extends Vue {
  @EventsModule.Getter isFeatureEnabled!: (featureName: FeatureFlag) => boolean;

  @Prop({ default: null }) readonly to!: LocationWithRawQuery | null;
  @Prop({ type: String, default: null }) readonly icon!: string;
  @Prop({ type: String, default: null }) readonly label!: string;
  @Prop({ type: Number, default: null }) readonly tabindex!: number;
  @Prop({ type: String, default: null }) readonly gatedFeature!: FeatureFlag | null;
  @Prop(Boolean) readonly isHidden!: boolean;
  @Prop(Boolean) readonly dropdown!: boolean;
  @Prop(Boolean) readonly currentActiveOnly!: boolean;
  @Prop(Boolean) readonly active!: boolean;
  @Prop(Boolean) isOpen!: boolean;

  @Ref() readonly upgradeModal?: UpgradeModal;

  @Emit() onToggle() {}

  isFocused = false;

  get isDisabledFeature() {
    return !!this.gatedFeature && !this.isFeatureEnabled(this.gatedFeature);
  }

  public toggleCollapsible() {
    this.onToggle();
  }

  public onBlur() {
    setTimeout(() => {
      this.isFocused = false;
    }, 200);
  }

  public showUpgradeModal({ target }: PointerEvent) {
    this.upgradeModal?.open(target);
  }
}
